import React, { Component } from 'react';

import SEO, { breadcrumbSchema } from '../common/SEO';
import Header from '../common/Header';
import Footer from '../common/Footer';
import SelfSpiel from '../common/SelfSpiel';

import ResourceLinks from './resources/ResourceLinks';
import Preloader from '../../hocs/Preloader';

const RESOURCES_JSON_LD = breadcrumbSchema([
  { name: "Home", path: "/" },
  { name: "Resources", path: "/resources" },
]);

class Resources extends Component {
  render() {
    return (
      <div id="page-container" className="full-height">
        <SEO
          title="Resources & Cheatsheets"
          description="A curated set of development references, cheatsheets, and guides shared by Fernan de Dios, AI & LLM lead developer, product builder, and SaaS founder."
          path="/resources"
          jsonLd={RESOURCES_JSON_LD}
        />
        <Header id="resources-banner" title="Resources" sub="References, Cheatsheets, Guides" />
        <ResourceLinks />
        <SelfSpiel />
        <Footer />
      </div>
    );
  }
}

export default Preloader(Resources);
